import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OutsideProfileComponent } from './authentication/outside-profile/outside-profile.component';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { CountriesResolver } from './core/resolvers/country.resolver';
import { LanguagesResolver } from './core/resolvers/language.resolver';
import { UserProfileResolver } from './core/resolvers/user.resolver';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    // canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
        path: 'page',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'multilevel',
        loadChildren: () =>
          import('./multilevel/multilevel.module').then(
            (m) => m.MultilevelModule
          )
      }
    ]
  },
  {
    path: 'userprofile/:id',
    component: OutsideProfileComponent,
    data: {
      title: 'OutsideProfile',
      breadcrumb: 'OutsideProfile'
    },
    resolve: {
      user: UserProfileResolver,
      languages: LanguagesResolver,
      countries: CountriesResolver,
    }
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },
  { path: '**', component: Page404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
